import React, { useState, useEffect, useCallback, useMemo, useContext} from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { inputOnlyNumbersWithDecimals } from '../../../utils/CommonUtilities.js';
import moment from 'moment';
import QRCode from 'qrcode';
import { useDropzone } from 'react-dropzone';
import config from '../../../config.js';
import useNotification from '../../../hooks/useNotification.js';
import { AuthContext } from '../../../contexts/authContext';

const baseStyle = {
    //flex: 1,
    width: '230px',
    height: '90px',
    //marginLeft: '50px',
    display: 'flex',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',

    //padding: '50px',
    borderWidth: 3,
    borderRadius: 5,
    borderColor: '#aaaaaa',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

async function createQRCode(lat, lon) {
    try {
        let urlQrCode = `https://www.google.com/maps?saddr=My+Location&daddr=${lat},${lon}`;
        let result = await QRCode.toDataURL(urlQrCode);
        
        return result;
    } catch (err) {
        console.error(err.message)
    }
}

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageEventsDialog(props) {
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();
    const [loading, setLoading] = useState(false);

    const [itname, setItname] = useState('');
    const [enname, setEnname] = useState('');
    const [location, setLocation] = useState('');
    const [lat, setLat] = useState('');
    const [lon, setLon] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [itdescription, setItdescription] = useState('');
    const [endescription, setEndescription] = useState('');
    const [base64Image, setBase64ImageValue] = useState(null);
    const [category, setCategory] = useState('');
    
    const [qrCodeImage, setQrCodeImage] = useState(null);

    const [originalItname, setOriginalItname] = useState('');
    const [originalEnname, setOriginalEnname] = useState('');
    const [originalLocation, setOriginalLocation] = useState('');
    const [originalLat, setOriginalLat] = useState('');
    const [originalLon, setOriginalLon] = useState('');
    const [originalStartDate, setOriginalStartDate] = useState(null);
    const [originalEndDate, setOriginalEndDate] = useState(null);
    const [originalItdescription, setOriginalItdescription] = useState('');
    const [originalEndescription, setOriginalEndescription] = useState('');
    const [originalBase64Image, setOriginalBase64Image] = useState(null);

    useEffect(() => {
        async function init(){
            if(props.openManageEventsDialog){
                getEvent();
            }else{
                setItname('');
                setEnname('');
                setLocation('');
                setLat('');
                setLon('');
                setStartDate(null);
                setEndDate(null);
                setItdescription('');
                setEndescription('');
                setBase64ImageValue(null);
                setQrCodeImage(null);
                setOriginalBase64Image(null)
            }
        }
        init()
    }, [props.openManageEventsDialog])

    const getEvent = async() => {
        try {
            setLoading(true);

            const params = {
                idEntita: props.lastCellData?.idEntita.S,
                city: props.lastCellData?.city.S
            };

            const axiosParams = {
                url: '/get-event',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            let itemData = response.data.result.Item;

            setItname(itemData.itname.S);
            setEnname(itemData.enname.S);
            setLocation(itemData.location.S);
            setLat(itemData.lat.S);
            setLon(itemData.lon.S);
            setStartDate(moment(itemData.period.SS[0], 'YYYYMMDD'));
            setEndDate(moment(itemData.period.SS[1], 'YYYYMMDD'));
            setItdescription(itemData.itdescription.S);
            setEndescription(itemData.endescription.S);
            
            setCategory(itemData.categoria.S);

            let qrcode = await createQRCode(itemData.lat.S, itemData.lon.S);
            setQrCodeImage(qrcode);

            setBase64ImageValue(itemData.photo.S);

            setOriginalItname(itemData.itname.S);
            setOriginalEnname(itemData.enname.S);
            setOriginalLocation(itemData.location.S);
            setOriginalLat(itemData.lat.S);
            setOriginalLon(itemData.lon.S);
            setOriginalStartDate(itemData.period.SS[0]);
            setOriginalEndDate(itemData.period.SS[1]);
            setOriginalItdescription(itemData.itdescription.S);
            setOriginalEndescription(itemData.endescription.S);
            setOriginalBase64Image(itemData.photo.S);

            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const modEvent = async() => {
        try {
            setLoading(true);
        
            const essentialData = {
                idEntita: props.lastCellData?.idEntita.S,
                city: props.lastCellData?.city.S
            }

            const data = {
                itname: itname === originalItname ? '' : itname,
                enname: enname === originalEnname ? '' : enname,
                location: location === originalLocation ? '' : location,
                lat: lat === originalLat ? '' : lat,
                lon: lon === originalLon ? '' : lon,
                itdescription: itdescription === originalItdescription ? '' : itdescription,
                endescription: endescription === originalEndescription ? '' : endescription,
            }

            if( (startDate.format('YYYYMMDD') !== originalStartDate) || (endDate.format('YYYYMMDD') !== originalEndDate) ){
                data.period = [startDate.format('YYYYMMDD'), endDate.format('YYYYMMDD')]
            }

            const dataToPass = {
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else if(element === 'period'){
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"SS": [...data[element]]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`; 
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length && base64Image === originalBase64Image){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }
            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            if(base64Image !== originalBase64Image){
                form.append('file', base64Image);
            }

            if(Object.keys(data).length){
                form.append('data', JSON.stringify(dataToPass))
            }

            const axiosParams = {
                url: '/mod-event',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: form
            };
            const response = await axios(axiosParams);
            notificationSuccess('Evento Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalItname(newOriginalItems.itname.S);
            setOriginalEnname(newOriginalItems.enname.S);
            setOriginalLocation(newOriginalItems.location.S);
            setOriginalLat(newOriginalItems.lat.S);
            setOriginalLon(newOriginalItems.lon.S);
            setOriginalStartDate(newOriginalItems.period.SS[0]);
            setOriginalEndDate(newOriginalItems.period.SS[1]);
            setOriginalItdescription(newOriginalItems.itdescription.S);
            setOriginalEndescription(newOriginalItems.endescription.S);
            setOriginalBase64Image(newOriginalItems.photo.S);
            //per l'immagine devo resettare anche il corrente siccome il datatype è diverso
            setBase64ImageValue(newOriginalItems.photo.S);

            let qrcode = await createQRCode(newOriginalItems.lat.S, newOriginalItems.lon.S);
            setQrCodeImage(qrcode);

            props.getEvents();
            
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const onDrop = useCallback(async(acceptedFiles) => {
		//devo prendere il file e renderlo base64 per poi storarlo
        if(acceptedFiles.length===0){
            notificationInfo('Sono accette solo immagini in formato .jpg');
            return;
        }
        setBase64ImageValue(acceptedFiles[0])
	}, []);

	const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        open,
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: {'image/jpeg':['.jpg'] },  multiple: false/* , maxFiles: 1, maxSize: 31457280 */});

	const dropZonestyle = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <Dialog className="dialog-mod-event" open={props.openManageEventsDialog} onClose={props.handleCloseManageEventDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{originalItname || ''}</DialogTitle>
            <DialogContent>
                <div className='dialog-events-wrapper'>
                    <div className='dialog-events-wrapper-fields'>
                        <div className="dialog-events-fields">
                            <TextField
                                className="dialog-itname required-field-bg"
                                id="dialog-itname"
                                label="Nome-IT"
                                type="text"
                                value={itname}
                                onChange={(event) => {
                                    setItname(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                                inputProps={{
                                    maxLength: 40
                                }}
                            />
                            <TextField
                                className="dialog-enname required-field-bg"
                                id="dialog-enname"
                                label="Nome-EN"
                                type="text"
                                value={enname}
                                onChange={(event) => {
                                    setEnname(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                }}
                                inputProps={{
                                    maxLength: 40
                                }}
                            />
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-events-fields">
                            <TextField
                                className="dialog-location required-field-bg"
                                id="dialog-location"
                                label="Luogo dello svolgimento"
                                type="text"
                                value={location}
                                onChange={(event) => {
                                    setLocation(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                        <div className="dialog-events-fields">
                            <TextField
                                className="dialog-lat required-field-bg"
                                id="dialog-lat"
                                label="Latitudine"
                                type="text"
                                value={lat}
                                onChange={(event) => {
                                    if (inputOnlyNumbersWithDecimals(event.target.value)) setLat(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "250px"
                                }}
                            />

                            <TextField
                                className="dialog-lon required-field-bg"
                                id="dialog-lon"
                                label="Longitudine"
                                type="text"
                                value={lon}
                                onChange={(event) => {
                                    if (inputOnlyNumbersWithDecimals(event.target.value)) setLon(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "250px"
                                }}
                            />
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-events-fields periods-cat-block">
                                
                            <TextField
                                className="dialog-category required-field-bg"
                                id="dialog-category"
                                label="Categoria"
                                type="text"
                                value={category}
                                variant="standard"
                                style={{
                                    width: "100%",
                                    maxWidth: "250px"
                                }}
                                slotProps={{
                                    input: {
                                        readOnly: true
                                    }
                                }}
                            />    
                            <div className='dates-block'>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        className='dialog-start-date'
                                        label="Data inizio"
                                        value={startDate}
                                        onChange={(newValue) => setStartDate(newValue)}
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                variant: "standard",
                                                className: "required-field-bg",
                                                style:{
                                                    width: "100%",
                                                    maxWidth: "150px"
                                                }
                                            }
                                        }}
                                    />

                                    <DatePicker
                                        className='dialog-end-date'
                                        label="Data fine"
                                        value={endDate}
                                        onChange={(newValue) => setEndDate(newValue)}
                                        format="DD/MM/YYYY"
                                        slotProps={{
                                            textField: {
                                                variant: "standard",
                                                className: "required-field-bg",
                                                style:{
                                                    width: "100%",
                                                    maxWidth: "150px"
                                                }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </div>
                        <Divider variant="middle"/>
                        <div className="dialog-events-fields">
                            <div className='dialog-events-wrapper-fields-textarea'>
                                <label for="itdescrizione-textarea">Descrizione-IT</label>
                                <textarea
                                    className="notes-textarea"
                                    id="itdescrizione-textarea"
                                    rows={8}
                                    cols={50}
                                    maxLength={400}
                                    value={itdescription}
                                    onChange={(event) => setItdescription(event?.target.value)}
                                    placeholder='Descrizione-IT'
                                />
                                <div>{itdescription.length}/400</div>
                            </div>
                            <div className='dialog-events-wrapper-fields-textarea'>
                                <label for="endescrizione-textarea">Descrizione-EN</label>
                                <textarea
                                    className="notes-textarea"
                                    id="endescrizione-textarea"
                                    rows={8}
                                    cols={50}
                                    maxLength={400}
                                    value={endescription}
                                    onChange={(event) => setEndescription(event?.target.value)}
                                    placeholder='Descrizione-EN'
                                />
                                <div>{endescription.length}/400</div>
                            </div>
                        </div>
                    </div>
    
                    <div className='dialog-events-wrapper-fields-images'>
                        <img width="90" src={qrCodeImage}/>
                        <div className='dialog-events-wrapper-fields-image-section'>
                            <img width="134" height="100" src={originalBase64Image !== base64Image ? URL.createObjectURL(base64Image) : 'data:image/jpg;base64, '+originalBase64Image}/>
                            <div className="dropBox" {...getRootProps({style: dropZonestyle})}>
                                <input {...getInputProps()} />
                                <p style={{textAlign: "center"}}>Clicca per caricare l'immagine</p>
                                <p style={{textAlign: "center"}}>Oppure trascina qui</p>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => modEvent()}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageEventDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageEventsDialog